var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.232,
    height: 9.788,
    viewBox: "0 0 12.232 9.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40821",
    "data-name": "Group 40821",
    transform: "translate(-25.85 -281.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M2111.688-3629.512a.816.816,0,0,1-.837-.791v-.419h-1.463a.947.947,0,0,1-1.045-.8v-.636a.189.189,0,0,1,.209-.158.189.189,0,0,1,.209.158v.636a.568.568,0,0,0,.627.478h1.463v-6.379a.794.794,0,0,1,.573-.748l1.316-.416h-3.353a.628.628,0,0,0-.627.627v.836a.209.209,0,0,1-.209.208.209.209,0,0,1-.209-.208v-.836a1.046,1.046,0,0,1,1.045-1.045h4.807a.815.815,0,0,1,.836.79v.338h-.418v-.338a.4.4,0,0,0-.34-.388.209.209,0,0,1-.078.016h-.134l-2.5.789a.4.4,0,0,0-.288.374v7.116a.408.408,0,0,0,.418.4.426.426,0,0,0,.126-.02l2.511-.793a.4.4,0,0,0,.287-.352h.419a.8.8,0,0,1-.573.727l-2.508.791A.807.807,0,0,1,2111.688-3629.512Zm-3.971-3.219a.213.213,0,0,1-.149-.061.211.211,0,0,1,0-.295l1.316-1.316h-3.676a.209.209,0,0,1-.208-.209.209.209,0,0,1,.208-.208h3.676l-1.316-1.315a.21.21,0,0,1,0-.295.209.209,0,0,1,.148-.062.207.207,0,0,1,.149.062l1.671,1.67.007.007,0,.005h0c.006.007.007.008.007.01l.007.009,0,.007a.212.212,0,0,1-.028.259l-1.671,1.671A.214.214,0,0,1,2107.717-3632.73Z",
    transform: "translate(-2079 3920.272)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(28.6 281.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40820",
    "data-name": "Group 40820",
    transform: "translate(5 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42413",
    "data-name": "Path 42413",
    d: "M8.386,2.951V2.2A1.2,1.2,0,1,0,6,2.2v.755a2.191,2.191,0,1,0,2.39,0ZM6.394,2.2a.8.8,0,1,1,1.594,0v.551a2.162,2.162,0,0,0-1.594,0Zm.8,4.382A1.793,1.793,0,1,1,8.984,4.785,1.795,1.795,0,0,1,7.191,6.577Z",
    transform: "translate(-5 -1)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42414",
    "data-name": "Path 42414",
    d: "M14,15a.5.5,0,0,0-.2.954v.839a.2.2,0,0,0,.4,0v-.839A.5.5,0,0,0,14,15Zm0,.4a.1.1,0,1,1-.1.1A.1.1,0,0,1,14,15.4Z",
    transform: "translate(-11.807 -12.211)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualLogin);
export default __webpack_public_path__ + "static/media/manual-login.3b71f5db4c0d3e0939f917f0fe564ab3.svg";
export { ForwardRef as ReactComponent };